import { InputHTMLAttributes, forwardRef } from "react";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  containerClassName?: string;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({ label, containerClassName = "", className = "", style, ...rest }, ref) => (
  <div className={`flex flex-col gap-2 ${containerClassName}`}>
    {label && (
      <label className="font-opensans text-[14px] text-[#111] leading-none">
        {label}
      </label>
    )}
    <input ref={ref} className={`w-full h-[47px] rounded-[6px] border bg-white px-3 font-opensans text-[14px] text-[#111] outline-none placeholder:text-[#8F9098] ${className}`}
      style={{ borderColor: "#C5C6CC", ...style }}
      {...rest}
    />
  </div>
)
);

TextInput.displayName = "TextInput";

export default TextInput;
